import { sortBy, prop, curry } from 'ramda';

const sortDesc = curry(
  (sortProp, list) =>
    sortBy(prop(sortProp), list)
);

export default sortDesc;
